export var setValueOrMax = function (value, maxValue) {
    return value > maxValue ? maxValue : value;
};
export var setValueOrMin = function (value, minValue) {
    return value < minValue ? minValue : value;
};
export var setValueOrMinMax = function (value, minValue, maxValue) {
    if (value > minValue) {
        return setValueOrMax(value, maxValue);
    }
    else
        return setValueOrMin(value, minValue);
};
export var replaceNonDigits = function (value) { return String(value).replace(/[^\d]/g, ''); };
